import { Button, Div } from '@codesuma/baseline'
import { IDayCell } from '../../../services/calendar'
import { CalendarSystem } from '../../../services/settings'
import dayEvents from '../../../services/day-events'
import { eventTime, fromPhone } from '../../../services/phone-events'
import { PhoneMark } from '../../../components/phone-mark'
import { Section } from './section'
import style from './index.module.css'

// Today's events, under the two to-do lists and only on the month today is in.
//
// Both sources are in it, Emrouz's own and the phone's, the same way the day
// page shows them — what is on today does not care which store it came from —
// and the phone's carry the same small phone they carry there. Read-only here:
// a row is a tap through to today's page, which is where an event is opened. The slide leaves the whole section out when
// today has nothing on it, so this is only ever built with rows to show.
// Emits 'day-open' for the page to route on.
export const TodayEvents = (system: CalendarSystem, today: IDayCell, scroller: HTMLElement) => {
    const base = Section('رویدادهای امروز', scroller)
    // The Gregorian slide is LTR for its grid, but an event title is the user's
    // own prose — keep it reading right-to-left like the rest of the app.
    if (system === 'gregorian') base.attr('dir', 'rtl')

    for (const event of dayEvents.forDay(today)) {
        const row = Div()
        // The task row's shape: the title taking the width and its second thing
        // at the far end. Only the title is a tap target — a task row's ring has
        // no counterpart here, so there is nothing beside it to miss.
        row.addClass(style.task)

        const title = Button(event.title)
        if (fromPhone(event)) title.append(PhoneMark())
        title.addClass(style.taskTitle)
        title.on('click', () => base.emit('day-open', today))
        row.append(title)

        const time = Div(eventTime(event))
        time.addClass(style.eventTime)
        row.append(time)

        base.list.append(row)
    }

    return base
}
